import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "o-grid sticky" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--offset-0 o-grid__cell--9-480 o-grid__cell--offset-3-480 o-grid__cell--8-768 o-grid__cell--offset-3-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_3 = { class: "radio-tarif o-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tarifauswahl_element = _resolveComponent("tarifauswahl-element")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.tarifauswahlInformationen, (tarifauswahlInformation) => {
          return (_openBlock(), _createBlock(_component_tarifauswahl_element, {
            key: tarifauswahlInformation.tarifNummer,
            tarifauswahlInformation: tarifauswahlInformation,
            anzahlElemente: _ctx.props.tarifauswahlInformationen.length
          }, null, 8, ["tarifauswahlInformation", "anzahlElemente"]))
        }), 128))
      ])
    ])
  ]))
}